/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  defaultSettings.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:29
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * 项目默认配置项
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 *
 */

export default {
  // vue-ls options
  storageOptions: {
    namespace: "fd__", // key prefix
    name: "ls", // name variable Vue.[ls] or this.[$ls],
    storage: "local", // storage name session, local, memory
  },
  maxNumberLen: 10, // 最大数值长度
  maxNumber: (max = 10) => Math.pow(10, max) - 1, // 最大数值
  primaryColor: '#DD2525', // primary color of ant design
};
